import {entrepreneursThatStartedExportOrImport} from './common/entrepreneurs-that-started-export-or-import';

/**
 * Survey: PROJECT- BASELINE IMPACT
 * Question: Is your company currently engaged in importing?
 * 
 * == baseline
 * import_t0
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: Is your company currently engaged in importing?
 * 
 * == final
 * import_t1
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatStartedImportTotalCalculation = (props: any) => {
    return entrepreneursThatStartedExportOrImport(props, 'import_t0', 'import_t1', 'No');
}